import { Typography } from "@mui/material";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import type { Dayjs } from "dayjs";
import type { FC } from "react";
import dayjs from "../../dayjs";
import "./MonthPicker.scss";

interface Props {
  readonly value: Dayjs;
  readonly label: string;
  readonly onChange: (v: Dayjs | null) => void;
}

const StaticMonthPicker: FC<Props> = ({ label, value, onChange }) => (
  <div className="month-picker">
    <Typography variant="subtitle1">{label}</Typography>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StaticDatePicker
        value={value}
        views={["month", "year"]}
        openTo="month"
        onChange={onChange}
        minDate={dayjs().subtract(5, "years")}
        maxDate={dayjs().add(5, "years")}
      />
    </LocalizationProvider>
  </div>
);

export default StaticMonthPicker;
